import { Component, OnInit } from '@angular/core';
import { RatingService } from './rating.service';

@Component({
  selector: 'rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {

  // public selectedRating:number = 0;
  // public description:string = '';

  constructor(public ratingService: RatingService) { 
    this.ratingService.ratingObj = {count: 0, description: ''};
  }

  ngOnInit() {}
  
  selectedRatingStar(rating:number){
    this.ratingService.ratingObj.count = rating;
  }
}
